module.exports = __webpack_public_path__ + "img/QW4104.5x8SD.c1ea9fb4.jpg";